/** 本地存储工具方法 */

function genKey(key) {
  return ['twg', key].join('/')
}

class LocalState {
  constructor() {
    this.$state = window.localStorage
    this.setItem = this.set
    this.getItem = this.get
    this.removeItem = this.remove
  }

  get length() {
    return this.$state.length
  }

  set(key, value) {
    key = genKey(key)
    this.$state.setItem(key, JSON.stringify(value))
  }

  remove(key) {
    key = genKey(key)

    this.$state.removeItem(key)
  }

  get(key) {
    key = genKey(key)
    return JSON.parse(this.$state.getItem(key))
  }

  clear() {
    this.$state.clear()
  }
}

export default new LocalState()
